import React from 'react'
import { Card } from 'antd'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import PageHeaderWrapper from '../../components/PageHeaderWrapper/PageHeaderWrapper'
import Stakeholders from './components/Stakeholders'

const CompanyInformation: React.FC = () => {
  const location = useLocation()

  const { t } = useTranslation()

  return (
    <PageHeaderWrapper title={t(`menu:${location.pathname}`)} ghost={false}>
      <Card>
        <Stakeholders />
      </Card>
    </PageHeaderWrapper>
  )
}

export default CompanyInformation
